wbApp.directive('wbSameValueValidator', [function () {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function (scope, elem, attr, ctrl) {

            attr.$observe('wbSameValueValidator', function (val) {
                ctrl.$setValidity('sameValue', ctrl.$viewValue === val);
            });

            scope.$watch(attr.ngModel, function (model) {
                var otherVal = attr.wbSameValueValidator;
                ctrl.$setValidity('sameValue', model === otherVal);
            });
        }
    };
}]);